import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

import { stripMarks } from './OrgBriefing';
import styles from './OrgAnalyze.module.scss';

// The model's questions for the reader: what would sharpen this analysis.
// Collapsible once a conversation is underway.
export default function RefineQuestions({ questions, collapsible }) {
  const items = questions ?? [];
  const [open, setOpen] = useState(!collapsible);

  useEffect(() => {
    if (!collapsible) {
      setOpen(true);
    }
  }, [collapsible]);

  if (items.length === 0) {
    return null;
  }

  if (collapsible && !open) {
    return (
      <div className={styles.refineCollapsed} data-test="org-refine-questions">
        <Button
          color="link"
          className="px-0"
          onClick={() => setOpen(true)}
          data-test="org-refine-expand"
        >
          Improve this analysis ({items.length})
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.refine} data-test="org-refine-questions">
      <div className={styles.refineHeader}>
        <h3 className={styles.sectionTitle}>Improve this analysis</h3>
        {collapsible ? (
          <Button color="link" className="px-0" onClick={() => setOpen(false)}>
            Hide
          </Button>
        ) : null}
      </div>
      <ul className={styles.refineList}>
        {items.map((question) => (
          <li key={question.question}>{stripMarks(question.question)}</li>
        ))}
      </ul>
    </div>
  );
}
